import { createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import type { AuthContext } from './lib/auth'
import { subscribeOrgResolveInvalidation } from './lib/org-utils'
import { BootLoaderUntilFirstMatch, RoutePendingFallback } from './components/layout/route-pending-fallback'
import { RouteErrorFallback } from './components/layout/route-error-fallback'

export type RouterContext = {
  auth: AuthContext
}

export const router = createRouter({
  routeTree,
  context: {
    auth: undefined!,
  },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  // Shown while a page's code chunk or beforeLoad is still loading, so no page ever renders blank.
  defaultPendingComponent: RoutePendingFallback,
  // A page whose code file vanished in a deploy reloads onto the same URL; other errors keep the standard view.
  // With a default set, every route catches its own errors inside the layout above it (the shell stays, navigating
  // away clears it). A layout's own `errorComponent` would not cover its child pages: they fall back to this one.
  defaultErrorComponent: RouteErrorFallback,
  InnerWrap: BootLoaderUntilFirstMatch,
})

// A saved salon-address mapping that proved wrong in its background re-check: re-run `/_auth/$orgId` beforeLoad,
// which resolves afresh and redirects (salon gone) or switches to the right salon.
subscribeOrgResolveInvalidation(() => {
  void router.invalidate()
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
